import { DEEPLINK_SCHEME } from './deeplink-scheme';
import { encodeSlug } from './encode-slug';

export function buildChallengeDeeplink(slug: string): string {
  return `${DEEPLINK_SCHEME}challenge/${encodeSlug(slug)}`;
}
